import React from 'react';
import { GraduationCapIcon } from 'lucide-react';
interface FooterProps {
  onNavigate?: (page: string) => void;
}
export function Footer({
  onNavigate
}: FooterProps) {
  const currentYear = new Date().getFullYear();
  const nav = (page: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) onNavigate(page);
  };
  return <footer className="bg-gray-50 border-t border-gray-200 py-12 mt-auto" data-id="element-437" data-mp="36nd4feb5q41k">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-438" data-mp="3ugbpd4c2b8hr">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8" data-id="element-439" data-mp="3991omvfnkca">
          {/* Logo + Description */}
          <div className="col-span-1 md:col-span-2" data-id="element-440" data-mp="3lf582t1l9tng">
            <button onClick={nav('compare')} className="flex items-center gap-2 hover:opacity-80 transition-opacity mb-4" data-id="element-441" data-mp="3lggb2qn7mxdi">
              <div className="bg-[#e8594f] text-white p-1.5 rounded-lg" data-id="element-442" data-mp="29zgkq0kfasm4">
                <GraduationCapIcon className="w-5 h-5" data-id="element-443" data-mp="2a19uhoqc1syc" />
              </div>
              <span className="text-lg font-bold text-gray-900 tracking-tight" data-id="element-444" data-mp="2ezuvhqdesgnu">
                FindOnlineDegrees
              </span>
            </button>
            <p className="text-sm text-gray-500 leading-relaxed max-w-md" data-id="element-445" data-mp="3gapf5opniuim">
              We help students find the right educational path by comparing top
              accredited online degree programs. Our mission is to make higher
              education more accessible and transparent.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-446" data-mp="817cg38o1ksh">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-447" data-mp="80nskgzggmbt">Quick Links</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-448" data-mp="33e5h7zjgmr5">
              <li data-id="element-449" data-mp="htd4te2ty487">
                <button onClick={nav('colleges')} className="hover:text-[#3b82f6] text-left" data-id="element-450" data-mp="hrs9hm8oyh9a">
                  Colleges
                </button>
              </li>
              <li data-id="element-451" data-mp="qt8grl47m39a">
                <button onClick={nav('compare')} className="hover:text-[#3b82f6] text-left" data-id="element-452" data-mp="qsqf28ys2wtz">
                  Compare Schools
                </button>
              </li>
              <li data-id="element-453" data-mp="tv4o84h2f862">
                <button onClick={nav('request-information')} className="hover:text-[#3b82f6] text-left" data-id="element-454" data-mp="tvmp5eeoaakb">
                  Match to Colleges
                </button>
              </li>
              <li data-id="element-455" data-mp="13tkey6c6kff1">
                <button onClick={nav('find-degrees')} className="hover:text-[#3b82f6] text-left" data-id="element-456" data-mp="13t0twgr8haws">
                  Find Degrees
                </button>
              </li>
              <li data-id="element-457" data-mp="1clmb3sf7v9ji">
                <button onClick={nav('explore')} className="hover:text-[#3b82f6] text-left" data-id="element-458" data-mp="1cm45skm8dfpb">
                  Explore
                </button>
              </li>
              <li data-id="element-459" data-mp="1hmiem4vnotoe">
                <button onClick={nav('program-information')} className="hover:text-[#3b82f6] text-left" data-id="element-460" data-mp="1mk1rb0cpgye8">
                  Program Information
                </button>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-461" data-mp="3ocgg8jdo3345">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-462" data-mp="3oczp7alcah61">Resources</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-463" data-mp="3tb9p1yi0e5xz">
              <li data-id="element-464" data-mp="2aevebtv95q6b">
                <button onClick={nav('articles')} className="hover:text-[#3b82f6] text-left" data-id="element-465" data-mp="2afdidco5p8os">
                  Articles
                </button>
              </li>
              <li data-id="element-466" data-mp="25mkd8norzyc6">
                <button onClick={nav('partner-colleges')} className="hover:text-[#3b82f6] text-left" data-id="element-467" data-mp="21mjy10turj42">
                  Partner Colleges
                </button>
              </li>
              <li data-id="element-468" data-mp="1wlw2c1uoie3i">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-469" data-mp="2tehq8i3yowev">
                  Financial Aid Guide
                </a>
              </li>
              <li data-id="element-470" data-mp="2pdpcpco245cs">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-471" data-mp="2pa9ysd64d2cy">
                  Career Outlooks
                </a>
              </li>
              <li data-id="element-472" data-mp="2fegnsy81tgxa">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-473" data-mp="2fezvlm3zioxl">
                  Student Reviews
                </a>
              </li>
            </ul>
          </div>

          {/* About Us */}
          <div data-id="element-474" data-mp="13ys2ebag0pyl">
            <h4 className="font-bold text-gray-900 mb-4" data-id="element-475" data-mp="13y08r60ep2ay">About Us</h4>
            <ul className="space-y-2 text-sm text-gray-600" data-id="element-476" data-mp="2rvzib1bupjnw">
              <li data-id="element-477" data-mp="2rtmtc47oe91c">
                <a href="#" className="hover:text-[#3b82f6]" data-id="element-478" data-mp="2wmfxoqz8ffcw">
                  Contact Us
                </a>
              </li>
              <li data-id="element-479" data-mp="2ivue101yf1dy">
                <button onClick={nav('privacy-policy')} className="hover:text-[#3b82f6] text-left" data-id="element-480" data-mp="2iwchagn1afvd">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-481" data-mp="3bjgs528t5of2">
                <button onClick={nav('terms')} className="hover:text-[#3b82f6] text-left" data-id="element-482" data-mp="3bl1o8wartff1">
                  Terms & Conditions
                </button>
              </li>
              <li data-id="element-483" data-mp="31m2dn86g39pe">
                <button onClick={nav('cookie-policy')} className="hover:text-[#3b82f6] text-left" data-id="element-484" data-mp="31khj3ik4rqrj">
                  Cookie Policy
                </button>
              </li>
              <li data-id="element-485" data-mp="1q5ui3qpfkyn8">
                <button onClick={nav('ca-notice')} className="hover:text-[#3b82f6] text-left" data-id="element-486" data-mp="1q5cda5opdc3p">
                  CA Notice at Collection
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8" data-id="element-487" data-mp="1nkedcm2kxlwc">
          <p className="text-xs text-gray-400 text-center mb-4" data-id="element-488" data-mp="1ine8gehgup6t">
            Advertising Disclosure: This website is an independent,
            advertising-supported comparison service. The offers that appear on
            this site are from companies from which we receive compensation.
            This compensation may impact how and where products appear on this
            site (including, for example, the order in which they appear). We do
            not include all available products or offers.
          </p>
          <p className="text-sm text-gray-500 text-center" data-id="element-489" data-mp="1dotegwst51qt">
            &copy; {currentYear} FindOnlineDegrees. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}